import React from 'react';

interface WaveDividerProps {
    fillClass: string;
    flip?: boolean;
    className?: string;
}

const WaveDivider: React.FC<WaveDividerProps> = ({ fillClass, flip = false, className = '' }) => (
    <div
        className={`w-full overflow-hidden leading-[0] ${flip ? 'rotate-180' : ''} ${className}`}
        aria-hidden
    >
        <svg className={`relative block w-full h-10 sm:h-14 ${fillClass}`} viewBox="0 0 1440 56" preserveAspectRatio="none">
            <path
                fill="currentColor"
                d="M0,28 C360,56 720,0 1080,28 C1260,42 1380,14 1440,28 L1440,56 L0,56 Z"
            />
        </svg>
    </div>
);

export default WaveDivider;
